<template>
  <img v-if="tlcManufacturer === tlcManufacturers.huaweiCloud" :class="marginClass || 'mar-rgt-5'"
       class="md-logo" src="../../../assets/huaweiLogo.jpeg"/>
  <img v-else-if="tlcManufacturer === tlcManufacturers.tencent" :class="marginClass || 'mar-rgt-5'"
       class="md-logo" src="../../../assets/tencentMt.png"/>
  <img v-else-if="tlcManufacturer === tlcManufacturers.xyLink" :class="marginClass || 'mar-rgt-5'"
       class="md-logo" src="../../../assets/xyLink.png"/>
  <span v-else-if="tlcManufacturer === tlcManufacturers.customTlc"
        :class="marginClass || 'mar-rgt-5'">{{sysTlcNameMap[tlcManufacturer]}}</span>
  <img v-else-if="tlcManufacturer === tlcManufacturers.zoom"
       class="sm-logo" :class="marginClass || 'mar-rgt-5'" src="../../../assets/zoomLogo.png"/>
</template>

<script>
  import {tlcConfig} from "../../../config/common";

  export default {
    props: {
      tlcManufacturer: String,
      marginClass: String
    },
    data() {
      return {
        tlcManufacturers: tlcConfig.manufacturers,
      }
    },
    computed: {
      sysTlcNameMap() {
        const map = {};
        const {tlcMFSettings} = this.$store.state.sysConfig;
        (tlcMFSettings || []).forEach(e => map[e.manufacturer] = e.name);
        return map
      },
    },
  }
</script>

<style scoped>
</style>
